import useTenantScope from 'LearningManager/hooks/useTenantScope';

export const useAudienceTenantId = (tenantId?: number) => {
	const { canSelectTenant, globalTenantId, scopedTenant, groups, scopedTenantLabel, nonTenantUser } = useTenantScope();

	const audienceTenantId =
		tenantId ??
		(canSelectTenant ? globalTenantId : Number(scopedTenant) || undefined);

	return {
		tenantId: audienceTenantId,
		tenantName: scopedTenantLabel,
		systemGroupIds: groups?.map(Number)?? [],
		isTenantResolved: canSelectTenant || Boolean(audienceTenantId),
		nonTenantUser
	};
};

export default useAudienceTenantId;
